<template>
  <v-container class="pa-4">
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          dark
          class="mb-4"
          @click="redirectTo()"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex justify-center">
        <div style="max-height: 240px">
          <img
            :src="dataItem.image_url"
            style="
              max-width: 100%;
              max-height: 240px;
              width: auto;
              height: auto;
              border-radius: 10px;
              object-fit: contain;
              display: block;
              margin: 0 auto;
            "
            @error="onImageError($event, dataItem, 'image_url')"
          />
        </div>
      </v-col>
    </v-row>

    <v-tabs
      v-model="tab"
      background-color="transparent"
      :color="site.color"
      fixed-tabs
      flat
      class="mt-2"
      style="margin-bottom: 120px"
    >
      <v-tab
        href="#tab-1"
        style="background: #ffffff; border-radius: 8px 0px 0px 0px"
        >{{ $t("detail") }}
      </v-tab>
      <v-tab
        href="#tab-2"
        style="background: #ffffff; border-radius: 0px 8px 0px 0px"
      >
        {{ $t("activity") }}
      </v-tab>
      <v-tabs-items v-model="tab" class="mt-2" style="border-radius: 8px">
        <v-tab-item :value="'tab-1'">
          <v-row no-gutters class="mt-3">
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="12">
                  <p
                    class="text-subtitle-1 text--primary mx-0 text-center mb-0"
                  >
                    {{ dataItem.name }}
                  </p>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-chip
                    class="mb-4 mt-2 ml-2 text-center white--text"
                    :color="site.color"
                    small
                  >
                    {{ category(dataItem.category) }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-chip
                    v-if="dataItem.is_top_ranking"
                    class="mt-2 mb-4 mr-2 text-center"
                    :color="site.color"
                    small
                    outlined
                    @click="goToTopRanking"
                  >
                    {{ $t("textTopRanking") }}
                    <v-icon small> mdi-chevron-right </v-icon>
                  </v-chip>
                </v-col>

                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-chip
                    class="mb-4 ml-2"
                    color="black"
                    dark
                    small
                    v-if="dataItem.anonymous == true"
                  >
                    <v-icon small>mdi-account-cowboy-hat-outline</v-icon>
                    {{ $t("textIncognito") }}
                  </v-chip>
                </v-col>

                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-row no-gutters>
                    <v-col
                      cols="12"
                      class="text-start pa-0 d-flex justify-start align-center mb-4"
                    >
                      <div class="ml-4" style="width: 48px">
                        <v-icon :color="site.color">mdi-calendar-clock</v-icon>
                      </div>
                      <div>
                        <div style="font-size: 10px">
                          {{ $t("activityExpireDate") }}
                        </div>
                        <div style="font-size: 14px; color: #00000099">
                          {{ dataItem.end_date | formatDate }}
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      class="text-start pa-0 d-flex justify-start align-center mb-4"
                      v-if="dataItem.use_reward == false"
                    >
                      <div class="ml-4" style="width: 48px">
                        <PointSymbol
                          v-if="
                            Array.isArray(dataItem.point) &&
                            dataItem.point.length > 0
                          "
                          :type="dataItem.point[0].point_type_type"
                          :symbol="dataItem.point[0].point_type_symbol"
                          :color="dataItem.point[0].point_type_color"
                          :is_display="true"
                          :outlined_box="false"
                          :size="30"
                        />
                      </div>
                      <div>
                        <div style="font-size: 10px">
                          {{ $t("collectCoin") }}
                        </div>
                        <div style="font-size: 14px; color: #00000099">
                          {{ showPoint(dataItem) }}
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      class="text-start pa-0 d-flex justify-start align-center mb-4"
                      v-else
                    >
                      <div class="ml-4" style="width: 48px">
                        <v-icon :color="site.color">mdi-gift</v-icon>
                      </div>
                      <div>
                        <div style="font-size: 10px">
                          {{ $t("missionReward") }}
                        </div>
                        <div style="font-size: 14px; color: #00000099">
                          {{ getRewardName(dataItem) }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-card elevation="0">
                        <p class="text-subtitle-2 mb-0 ml-4 font-weight-bold">
                          {{ $t("detail") }}
                        </p>
                        <div
                          class="ml-4 ql-editor"
                          style="height: fit-content"
                          v-html="formatHtmlDetail(dataItem.detail)"
                        ></div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <questTrackingData
              v-if="dataItem.type == 'quest-tracking'"
              :questTrackingData="questTrackingData"
              :conditionSpecial="conditionSpecial"
              :site="site"
            ></questTrackingData>
          </v-row>
        </v-tab-item>
        <v-tab-item :value="'tab-2'" class="px-2 pb-2">
          <StatusExpansionPanels
            :img_url="dataItem.image_url"
            :panels="dataListMyMission"
            :employee_id="dataItem.employee_mission_id"
            :openPanel="openPanel"
            :showPanel="showPanel"
            :dataMission="dataItem"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <v-footer fixed padless color="white">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-row class="pt-4" justify="center">
              <v-col
                v-if="initial_check_allow_play"
                cols="11"
                md="3"
                class="py-0 pb-4"
              >
                <!-- ========== ========== require_qr ========== ========== -->
                <v-btn
                  v-if="dataItem.require_qr"
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="openQrDialog()"
                >
                  {{ $t("activityQr") }}
                </v-btn>
                <!-- ========== ========== not require_qr ========== ========== -->
                <v-btn
                  v-else
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="confirmMission()"
                >
                  {{ $t("activityJoin") }}
                </v-btn>
              </v-col>
              <!-- ========== ========== Button Back ========== ========== -->
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg"
                  :color="site.color"
                  outlined
                  @click="redirectTo()"
                >
                  {{ $t("back") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <DialogScan
      :dialogScan="dialogScan"
      :refMissionId="missionId"
      @closeDialogScan="dialogScan = false"
      @onScanSuccess="handleScanSuccess"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Axios from "@/config/customer-service";
import moment from "moment";
import questTrackingData from "./component/questTrackingData.vue";
import DialogScan from "@/components/activity/dialogScan.vue";
import StatusExpansionPanels from "@/views/Customer/Mission/component/listMyMission.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";
import { formatHtmlDetailDefault } from "../../../config/general-function.js";

export default {
  components: {
    questTrackingData,
    DialogScan,
    StatusExpansionPanels,
    PointSymbol,
  },
  data: () => ({
    drawer: false,
    dataItem: [],
    qrcode_key: "",
    dialogScan: false,
    error: "",
    employee_mission_id: "",
    result: "",
    kahoot_link: "https://kahoot.it/",
    questTrackingData: [],
    conditionSpecial: {},
    dialogItemQuestTracking: false,
    selectItem: {},
    tab: "tab-1",
    openPanel: [0, 1, 2, 3],
    showPanel: true,
    dataListMyMission: [
      {
        key: "join",
        label: "กำลังเข้าร่วม",
        color: "blue",
        bgColor: "#E3F2FD",
        icon: "mdi-account-reactivate-outline",
        panelStyle: {
          border: "1px solid #2196F3",
        },
        count: 0,
        items: [],
        total_reward: [],
      },
      {
        key: "waiting",
        label: "รออนุมัติ",
        color: "orange",
        bgColor: "#FFF3E0",
        icon: "mdi-clock-outline",
        panelStyle: {
          border: "1px solid orange",
        },
        count: 0,
        items: [],
        total_reward: [],
      },
      {
        key: "success",
        label: "สำเร็จ",
        color: "green",
        bgColor: "#E8F5E9",
        icon: "mdi-check-circle-outline",
        panelStyle: {
          border: "1px solid green",
        },
        count: 0,
        items: [],
        total_reward: [],
      },
      {
        key: "failed",
        label: "ไม่สำเร็จ",
        color: "red",
        bgColor: "#FFEBEE",
        icon: "mdi-close-circle-outline",
        panelStyle: {
          border: "1px solid red",
        },
        count: 0,
        items: [],
        total_reward: [],
      },
    ],
    missionId: null,
    previousRouteName: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
    });
  },
  created() {
    this.getMissionDetail();
    this.getListMymission();
  },
  methods: {
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    openDialog(item) {
      this.selectItem = item;
      this.dialogItemQuestTracking = true;
    },
    goToTopRanking() {
      this.$router.push({
        name: "top-ranking",
        params: {
          id: this.dataItem.id,
        },
      });
    },
    redirectTo() {
      if (this.previousRouteName) {
        const fromName = this.$router.previousRouteFrom?.name;
        if (
          [
            "mission-survey",
            "mission-upload",
            "mission-lucky-draw",
            "mission-checkin",
          ].includes(fromName)
        ) {
          this.$router.push({
            name: "mission",
          });
          return;
        }
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "mission",
        });
      }
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        console.log("error :>> ", error);
        if (error.name === "NotAllowedError") {
          this.error = this.$t("cameraError.notAllowed");
        } else if (error.name === "NotFoundError") {
          this.error = this.$t("cameraError.notFound");
        } else if (error.name === "NotSupportedError") {
          this.error = this.$t("cameraError.notSupported");
        } else if (error.name === "NotReadableError") {
          this.error = this.$t("cameraError.notReadable");
        } else if (error.name === "OverconstrainedError") {
          this.error = this.$t("cameraError.overconstrained");
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = this.$t("cameraError.streamApiNotSupported");
        } else if (error.name === "InsecureContextError") {
          this.error = this.$t("cameraError.insecureContext");
        } else {
          this.error = this.$t("cameraError.unknown", {
            error_name: error.name,
          });
        }
      }
    },
    getMissionDetail() {
      Axios.get("mission/getMission", {
        params: {
          mission_id: this.$route.params.id,
          view_in_period_remind_date: true,
          view_limit_reached: true,
        },
      })
        .then(({ data }) => {
          this.dataItem = data.data;
          this.missionId = this.dataItem.id;
          this.$store.commit("login/SET_URL_REDIRECT", { urlRedirect: "" });
          this.questTrackingData = this.dataItem.quest_tracking_data;
          this.conditionSpecial = this.dataItem.condition_special;
        })
        .catch((err) => {
          console.log("err :>> ", err);
          this.$router.push({
            name: "mission",
          });
        });
    },
    openQrDialog() {
      this.dialogScan = true;
    },
    handleScanSuccess(param) {
      const mission_type = param.mission_type;
      const employee_mission = param.employee_mission;
      if (mission_type == "quest-tracking") {
        this.$router.push({
          name: "my-mission-detail",
          params: { id: employee_mission.id },
        });
        return;
      }
    },

    // ========== ========== Confirm Mission ========== ==========
    confirmMission() {
      if (["upload"].includes(this.dataItem.type)) {
        this.confirmUpload();
      } else if (["kahoot"].includes(this.dataItem.type)) {
        this.confirmKahoot();
      } else if (["check-in"].includes(this.dataItem.type)) {
        this.confirmCheckin();
      } else if (["lucky draw"].includes(this.dataItem.type)) {
        this.confirmLuckyDraw();
      } else if (["quest-tracking"].includes(this.dataItem.type)) {
        this.confirmQuestTracking();
      } else if (
        ["survey", "exam", "multi-upload", "survey-summary"].includes(
          this.dataItem.type
        )
      ) {
        this.confirmSurvey();
      }
    },
    confirmSurvey() {
      Axios.post("mission/takeMission", {
        mission_id: this.dataItem.id,
        qr_code: this.qrcode_key,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({
              name: "mission-survey",
              params: { id: data.data.employee_mission_id },
            });
          } else if (data.status == "join") {
            this.$router.push({
              name: "mission-survey",
              params: { id: data.data.id },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch(() => {
          this.$router.push({
            name: "mission",
          });
        });
    },
    confirmUpload() {
      Axios.post("mission/takeMission", {
        mission_id: this.dataItem.id,
        qr_code: this.qrcode_key,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({
              name: "mission-upload",
              params: { id: data.data.employee_mission_id },
            });
          } else if (data.status == "join") {
            this.$router.push({
              name: "mission-upload",
              params: { id: data.data.id },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch(() => {
          this.$router.push({
            name: "mission",
          });
        });
    },
    confirmQuestTracking() {
      Axios.post("mission/takeMission", {
        mission_id: this.dataItem.id,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });

            this.$router.push({
              name: "my-mission-detail",
              params: { id: data.data.employee_mission_id },
              query: { from: "all" },
            });
          }
        })
        .catch(() => {
          this.$router.push({
            name: "mission",
          });
        });
    },
    confirmLuckyDraw() {
      Axios.post("mission/takeMission", {
        mission_id: this.dataItem.id,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({
              name: "mission-lucky-draw",
              params: { id: data.data.employee_mission_id },
            });
          } else if (data.status == "join") {
            this.$router.push({
              name: "mission-lucky-draw",
              params: { id: data.data.id },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch(() => {
          this.$router.push({
            name: "mission",
          });
        });
    },
    confirmCheckin() {
      Axios.post("mission/takeMission", {
        mission_id: this.dataItem.id,
        qr_code: this.qrcode_key,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({
              name: "mission-checkin",
              params: { id: data.data.employee_mission_id },
            });
          } else if (data.status == "join") {
            this.$router.push({
              name: "mission-checkin",
              params: { id: data.data.id },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch(() => {
          this.$router.push({
            name: "mission",
          });
        });
    },
    confirmKahoot() {
      Axios.post("mission/takeMission", {
        mission_id: this.dataItem.id,
        qr_code: this.qrcode_key,
      })
        .then(({ data }) => {
          if (data.status == "success" && this.dataItem.type != "kahoot") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });

            this.employee_mission_id = data.data.employee_mission_id;
            setTimeout(() => {
              if (this.dataItem.link_kahoot != null) {
                return window.open(this.dataItem.link_kahoot, "_blank");
              } else {
                return window.open(this.kahoot_link, "_blank");
              }
            }, 2000);
          } else if (
            data.status == "success" &&
            this.dataItem.kahoot_type != "game"
          ) {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });

            this.employee_mission_id = data.data.employee_mission_id;
            setTimeout(() => {
              if (this.dataItem.link_kahoot != null) {
                return window.open(this.dataItem.link_kahoot, "_blank");
              } else {
                return window.open(this.kahoot_link, "_blank");
              }
            }, 2000);
          } else {
            this.$swal.fire({
              icon: "success",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });

            this.employee_mission_id = data.data.employee_mission_id;
            setTimeout(() => {
              if (this.dataItem.link_kahoot != null) {
                return window.open(this.dataItem.link_kahoot, "_blank");
              } else {
                return window.open(this.kahoot_link, "_blank");
              }
            }, 2000);
          }
        })
        .catch(() => {
          this.$router.push({
            name: "mission",
          });
        });
    },
    // ========== ========== ========== ==========

    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
    getRewardName(data) {
      let rewards = data.mission_rewards;
      if (rewards == undefined) {
        return "-";
      } else if (rewards.length == 0) return "-";
      else return rewards.map((reward) => reward.name).join(", ");
    },
    showPoint(pararm) {
      let pointDetail = {
        point: 0,
        point_type_name: "",
      };
      if (Array.isArray(pararm.point) && pararm.point.length > 0) {
        pointDetail = pararm.point[0];
      }
      if (pararm.use_reward == true) {
        return `${this.$t("rewardPrize")}`;
      } else if (pointDetail.point == 0 || pararm.type == "check-in") {
        return `${this.$t("conditionCoin")}`;
      } else if (Array.isArray(pararm.point) && pararm.point.length > 1) {
        // return `${this.$t("textNumberMore", { number: pararm.point.length })}`;
        return `+${pararm.point.length}`;
      } else {
        const formattedPoint = this.$options.filters.commaPoint(
          pointDetail.point
        );
        return `${formattedPoint} ${pointDetail.point_type_name}`;
      }
    },
    category(value) {
      if (!value) return this.$t("textNotSpecified");
      return value;
    },
    async getListMymission() {
      try {
        const listMyMission = await Axios.get("mission/getListMyMission", {
          params: { mission_id: this.$route.params.id },
        });
        let listData = listMyMission.data.data;
        listData.forEach((element) => {
          this.dataListMyMission[element.status].count = element.count;
          this.dataListMyMission[element.status].items = element.items;
          this.dataListMyMission[element.status].total = element.total;
          this.dataListMyMission[element.status].total_reward =
            element.total_reward;
        });

        //open panel
        if (listData.length > 0) {
          this.showPanel = true;

          let from = this.$route.query.from;
          if (from == undefined || from == "all") {
            this.openPanel = [0, 1, 2, 3];
          } else {
            this.openPanel = [Number.parseInt(from)];
          }
        } else {
          this.showPanel = false;
        }
      } catch (err) {
        console.log("err :>> ", err);
        this.$router.push({
          name: "mission",
        });
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    initial_check_allow_play() {
      return (
        !this.dataItem.limit_reached &&
        this.dataItem.quest_tracking_allow_play &&
        this.dataItem.has_permission_play &&
        !this.dataItem.in_period_remind_date &&
        this.dataItem.in_period_show_time_selected
      );
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.spaceBottom {
  margin-bottom: 25%;
}
.item-detail > h1 {
  line-height: 2rem;
}
img {
  width: 100% !important;
}
::v-deep .v-expansion-panel-content__wrap {
  padding: 0px 12px 12px 12px !important;
}
</style>
